import { View } from "binder"
import { ToolModelEditorViewModel } from "./toolModelEditor-viewModel"
import { ToolTypeSelectorViewModel } from "../toolTypeSelector-viewModel";

export class ToolModelEditorView extends View<ToolModelEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-5B189C11-F68C-409F-857F-08B413290FC3"
    }
    loadHtml(): string {
        let element = require('./toolModelEditor.html').default;
        let style = require('./toolModelEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set hasReplacableTool(v: boolean) { this._hasReplacableTool = v; } public get hasReplacableTool(): boolean { return this._hasReplacableTool; } private _hasReplacableTool: boolean;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeSelector(v: ToolTypeSelectorViewModel) { this._toolTypeSelector = v; } public get toolTypeSelector(): ToolTypeSelectorViewModel { return this._toolTypeSelector; } private _toolTypeSelector: ToolTypeSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
